/* src/app/admin/tenant/tenant.component.scss */
/*# sourceMappingURL=tenant.component-YKRIWG5V.css.map */
